document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!form.matches('[data-product-form]')) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const original = button.textContent;
  button.textContent = 'Adding...';
  const formData = new FormData(form);
  try {
    await fetch('/cart/add.js', { method: 'POST', body: formData });
    button.textContent = 'Added';
    setTimeout(() => { window.location.href = '/cart'; }, 450);
  } catch (e) {
    button.textContent = 'Try again';
    setTimeout(() => button.textContent = original, 1200);
  }
});
